<template>
    <b-row class="item-header-row">
        <slot></slot>
    </b-row>
</template>
<script>
export default {
    name: 'ItemHeaderRow',
    props: {
        scrollToTop: {},
        validationErrors: {}
    }
}
</script>
<style scoped>
.item-header-row {
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
}
.flex-align-right {
    display: flex;
    justify-content: flex-end;
}
</style>
